import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LANG_OPTIONS } from "../Context/Constants";
import { useLanguageContext } from "../Context/LanguageContext";
import "./lang-switcher.css";

const LangSwitcher = ({ className = "" }) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const { selectedLang, setSelectedLang } = useLanguageContext();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const currentLabel = LANG_OPTIONS.find(([, value]) => value === selectedLang)?.[0] || "English";

  return (
    <div className={`lang-switcher ${className}`.trim()} ref={containerRef}>
      <button
        type="button"
        className="lang-toggle"
        aria-label={t("Language")}
        aria-expanded={open}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}>
        🌐 {currentLabel}
      </button>
      <div className={`lang-dropdown ${open ? "open" : ""}`}>
        {LANG_OPTIONS.map(([label, value]) => (
          <button
            key={value}
            type="button"
            className={`lang-option ${selectedLang === value ? "lang-active" : ""}`}
            onClick={() => {
              setSelectedLang(value);
              setOpen(false);
            }}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LangSwitcher;
